const required = (message) => (value) => (value && value.trim() ? null : message);

export default required;
